{
  "version": 1,
  "asset_id": "8e7cde52-c3eb-4caa-bf5e-cc042132ba99",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/8e7cde52-c3eb-4caa-bf5e-cc042132ba99/sleeve-hiatal-type-1-second-es-1254.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/8e7cde52-c3eb-4caa-bf5e-cc042132ba99/sleeve-hiatal-type-1-second-es-1254.webp",
  "original_filename": "sleeve-hiatal-type-1-second-es-1254.webp",
  "size": 85072,
  "content_type": "image/webp",
  "created_at": "2026-09-26T22:32:03Z"
}
